var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Введите данные",
      "outlined": "",
      "rounded": "",
      "dense": "",
      "error-messages": _vm.$errorMessages(_vm.$v.localPersonalContact.cellularPhone)
    },
    on: {
      "input": _vm.setPersonalContact,
      "blur": function blur($event) {
        return _vm.$v.localPersonalContact.cellularPhone.$touch();
      }
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "required"
        }, [_vm._v("Мобильный телефон")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.localPersonalContact.cellularPhone,
      callback: function callback($$v) {
        _vm.$set(_vm.localPersonalContact, "cellularPhone", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "localPersonalContact.cellularPhone"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Введите данные",
      "outlined": "",
      "rounded": "",
      "dense": "",
      "error-messages": _vm.$errorMessages(_vm.$v.localPersonalContact.homePhone)
    },
    on: {
      "input": _vm.setPersonalContact,
      "blur": function blur($event) {
        return _vm.$v.localPersonalContact.homePhone.$touch();
      }
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', [_vm._v("Домашний телефон")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.localPersonalContact.homePhone,
      callback: function callback($$v) {
        _vm.$set(_vm.localPersonalContact, "homePhone", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "localPersonalContact.homePhone"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Введите данные",
      "outlined": "",
      "rounded": "",
      "dense": "",
      "error-messages": _vm.$errorMessages(_vm.$v.localPersonalContact.email)
    },
    on: {
      "input": _vm.setPersonalContact,
      "blur": function blur($event) {
        return _vm.$v.localPersonalContact.email.$touch();
      }
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "required"
        }, [_vm._v("Электронная почта")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.localPersonalContact.email,
      callback: function callback($$v) {
        _vm.$set(_vm.localPersonalContact, "email", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "localPersonalContact.email"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }